import React from "react";
import PageShell from "@/components/PageShell";
import Approach from "@/components/Approach";
import Services from "@/components/Services";

export default function ApproachPage() {
    return (
        <PageShell>
            <Approach />
            <Services />
        </PageShell>
    );
}
